import { LoginSuccessAlert, LoginErrorAlert } from "../../components/alert/loginAlert";
import api from "../instance/axios_instance.ts";
import { LoginInterface } from "../interface/loginInterface";

export const LoginApi = async (email: string, password: string): Promise<LoginInterface | undefined> => {
    try {
        const response = await api.post<LoginInterface>('/login', { email, password }, { skipAuth: true } as any);
        console.log("Login success:", response.data);

        const token = response.data.access_token;
        localStorage.setItem('token', token);

        LoginSuccessAlert();
        setTimeout(() => {
            window.location.href = "/dashboard";
        }, 1500);

        return response.data;
    } catch (error: any) {
        console.error("Login error:", error);

        if (error.response) {
            const status = error.response.status;
            const detail = error.response.data?.detail;

            if (status === 401) {
                LoginErrorAlert("#d32f2f", "Contraseña incorrecta.");
            } else if (status === 404) {
                LoginErrorAlert("#d32f2f", "El usuario no existe.");
            } else if (status === 403) {
                LoginErrorAlert("#d32f2f", "Acceso denegado: Usuario no autorizado.");
            } else {
                LoginErrorAlert("#d32f2f", detail || "Error al iniciar sesión.");
            }
            return error.response.data;
        } else {
            LoginErrorAlert("#d32f2f", "Error de conexión con el servidor.");
        }
        throw error;
    }
};
